module.exports = __webpack_public_path__ + "media/newstyle/images/icon-lp-2-orange-d42f5a3eb987c3cd1b62b3c594b030ee.svg";